@if ((onlineOrdering$ | async) && !(isOrderBlocked$|async)) {
  <a [href]="'/cart'" (click)="openMiniCart($event)" [class.disabler]="!state">
    <mat-dialog-actions>
    <a [attr.aria-label]="
    'miniCart.item' | cxTranslate : { count: quantity$ | async }
  ">
        <div class="cart-block">
          <img class="cart-icon" src="/images/cart_grey.png" alt="icon" />
          <span class="total">
            {{ total$ | async }}
          </span>
          <span class="count">
            {{ (miniCartCount$ | async)?.length || 0 }}
          </span>
        </div>
      </a>
    </mat-dialog-actions>
  </a>
}